import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

interface Section {
  id: string;
  title: string;
  content: string[];
}

const sections: Section[] = [
  {
    id: "1",
    title: "第1条（個人情報の取得）",
    content: [
      "本サービスでは、以下の場合に個人情報を取得します：会員登録・アカウント設定時（氏名・メールアドレス・パスワード等）、コンテンツ購入時（決済情報・配送先住所等）、お問い合わせ・サポート利用時（氏名・メールアドレス・問い合わせ内容）、本サービスの利用時（アクセスログ・Cookieを通じた情報）。",
      "事業者として登録する場合は、上記に加え、サービス名・専門分野・プロフィール情報等を取得します。",
    ],
  },
  {
    id: "2",
    title: "第2条（個人情報の利用目的）",
    content: [
      "取得した個人情報は、以下の目的のためにのみ利用します：本サービスの提供・運営・改善、会員登録の管理・認証・サポート、コンテンツ購入・決済処理・配送手続き、メッセージ機能の提供、規約違反・不正行為の調査・対応、重要なお知らせや更新情報の通知（メールマガジン等）、利用動向の統計分析（個人を特定しない形式）。",
      "上記目的以外で個人情報を利用する場合は、事前に利用者の同意を得るものとします。",
    ],
  },
  {
    id: "3",
    title: "第3条（個人情報の第三者提供）",
    content: [
      "運営者は、以下の場合を除き、利用者の個人情報を第三者に提供しません：利用者の同意がある場合、法令に基づく要請・裁判所・警察等の公的機関からの正当な照会がある場合、人の生命・身体・財産の保護のために必要であり、利用者本人の同意を得ることが困難な場合、業務委託先（決済代行・配送業者等）への提供（利用目的の範囲内に限る）。",
      "教材キットの購入において配送が発生する場合、配送に必要な範囲で事業者に住所・氏名を提供することがあります。この場合、事業者は当社のプライバシーポリシーに準じた取り扱いを行う義務を負います。",
    ],
  },
  {
    id: "4",
    title: "第4条（メッセージ内容の取り扱い）",
    content: [
      "本サービスのメッセージ機能を通じたやり取りは、安全管理・規約違反調査・トラブル対応の目的に限り、運営者が内容を確認することがあります。",
      "メッセージ内容を上記目的以外で利用したり、第三者（司法機関・警察への提出を除く）に開示したりすることはありません。",
      "利用者はメッセージ機能を利用することで、上記の内容確認に同意したものとみなされます。",
    ],
  },
  {
    id: "5",
    title: "第5条（個人情報の保管・セキュリティ）",
    content: [
      "個人情報は、適切なセキュリティ対策を施したサーバーに保管します。不正アクセス・漏洩・改ざん防止のために合理的な技術的・組織的安全措置を講じます。",
      "個人情報は、利用目的を達成するために必要な期間保管します。退会後は、法令上必要な記録を除いてデータを削除します。",
    ],
  },
  {
    id: "6",
    title: "第6条（Cookieおよびアクセス解析）",
    content: [
      "本サービスでは、サービス改善・利用状況の分析を目的として、CookieおよびGoogleアナリティクス等のアクセス解析ツールを使用することがあります。",
      "収集されるデータはユーザーを直接特定するものではなく、統計的・匿名的に処理されます。",
      "ブラウザの設定によりCookieを無効にすることができますが、一部機能が使えなくなる可能性があります。",
    ],
  },
  {
    id: "7",
    title: "第7条（個人情報の開示・訂正・削除）",
    content: [
      "利用者は、自己の個人情報について開示・訂正・削除・利用停止を求めることができます。",
      "マイページから変更できる範囲の情報はご自身で更新できます。それ以外の手続きについては、お問い合わせフォームよりご連絡ください。",
      "法令に基づく保存義務がある場合や、正当な理由がある場合には、ご要望に応じかねることがあります。その場合は理由とともにご説明いたします。",
    ],
  },
  {
    id: "8",
    title: "第8条（未成年者の個人情報）",
    content: [
      "16歳未満の方が本サービスを利用する場合は、保護者の同意のもとで個人情報を提供してください。",
      "運営者が16歳未満の方の個人情報を保護者の同意なく取得したことが判明した場合、速やかに削除するよう努めます。",
    ],
  },
  {
    id: "9",
    title: "第9条（プライバシーポリシーの変更）",
    content: [
      "本プライバシーポリシーは、法令の改正・サービス内容の変更等に伴い、予告なく改定することがあります。",
      "重要な変更がある場合は、本サービス上でお知らせいたします。改定後も継続して本サービスをご利用いただいた場合は、変更後のポリシーに同意したものとみなします。",
    ],
  },
  {
    id: "10",
    title: "第10条（お問い合わせ窓口）",
    content: [
      "個人情報の取り扱いに関するご質問・ご要望・苦情は、本サービス内のお問い合わせフォームよりご連絡ください。特定のメールアドレスによる受付は行っておりません。",
      "お問い合わせの内容は、本プライバシーポリシーに従い適切に取り扱います。",
    ],
  },
];

export default function PrivacyPage() {
  const [openSection, setOpenSection] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="font-display italic text-gold text-xs tracking-widest mb-2">Privacy</p>
            <h1 className="font-serif text-deep-green text-3xl font-light mb-4">プライバシーポリシー</h1>
            <p className="text-charcoal/50 font-sans text-xs">最終更新日：2025年3月28日</p>
          </div>

          {/* Intro */}
          <div className="bg-teal/5 rounded-2xl p-6 mb-8 border border-teal/10">
            <div className="flex items-start gap-3">
              <i className="ri-shield-check-line text-teal text-xl flex-shrink-0 mt-0.5" />
              <p className="text-sm font-sans text-charcoal/80 leading-relaxed">
                TSUGITE（ツギテ）は、利用者の個人情報の保護を重要な責務と考えています。本プライバシーポリシーは、本サービスにおける個人情報の取り扱い方針を定めたものです。ご不明な点は、お問い合わせフォームよりご連絡ください。
              </p>
            </div>
          </div>

          {/* TOC */}
          <nav className="bg-white rounded-2xl p-6 mb-8 border border-stone-100">
            <p className="font-serif text-deep-green text-base mb-4">目次</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
              {sections.map(s => (
                <a
                  key={s.id}
                  href={`#priv-${s.id}`}
                  onClick={() => setOpenSection(s.id)}
                  className="text-sm font-sans text-charcoal/60 hover:text-teal transition-colors cursor-pointer py-1"
                >
                  {s.title}
                </a>
              ))}
            </div>
          </nav>

          {/* Sections */}
          <div className="space-y-3">
            {sections.map(s => (
              <div key={s.id} id={`priv-${s.id}`} className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
                <button
                  onClick={() => setOpenSection(openSection === s.id ? null : s.id)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 cursor-pointer hover:bg-stone-50 transition-colors text-left"
                >
                  <h2 className="font-serif text-deep-green text-base">{s.title}</h2>
                  <i className={`ri-arrow-down-s-line text-xl text-charcoal/40 transition-transform duration-300 flex-shrink-0 ${openSection === s.id ? "rotate-180" : ""}`} />
                </button>
                {openSection === s.id && (
                  <div className="px-6 pb-6 border-t border-stone-100 pt-4">
                    <div className="space-y-3">
                      {s.content.map((p, i) => (
                        <p key={i} className="text-sm font-sans text-charcoal/80 leading-relaxed">{p}</p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Links */}
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/terms" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-book-2-line" />利用規約
            </Link>
            <Link to="/faq" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-question-line" />よくある質問
            </Link>
            <Link to="/contact" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-mail-line" />お問い合わせ
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
